/** @format */
import { RefObject, useEffect } from 'react';

/**
 * This hook is used to listen to focus events within the dom element its attached to
 */
export const useFocusWithin = (
    ref: RefObject<HTMLElement>,
    handler: (event: Event) => void
) => {
    const focusHandler = (event: FocusEvent) => {
        handler(event);
    };

    useEffect(() => {
        ref.current &&
            ref.current.addEventListener('focus', focusHandler, true);

        return () => {
            ref.current &&
                ref.current.removeEventListener('focus', focusHandler, true);
        };
    }, [ref.current, handler]);
};
